import { useQueryClient } from '@tanstack/react-query';
import { Store } from 'lucide-react';
import { getVendorLogoUploadUrl, setVendorLogo, deleteVendorLogo } from '../../api/vendors';
import { uploadFileToS3 } from '../../api/photos';
import { RecordLogo } from '../common/RecordLogo';

export interface VendorLogoProps {
  vendorId: string;
  /** The vendor's logo, a resolved URL; null or absent when it has none. */
  logoUrl?: string | null;
  editable?: boolean;
  sizeClassName?: string;
}

/** A vendor's logo, else a shop icon; producers change it in place. */
export function VendorLogo({
  vendorId,
  logoUrl,
  editable = false,
  sizeClassName = 'w-12 h-12',
}: VendorLogoProps) {
  const queryClient = useQueryClient();
  return (
    <RecordLogo
      imageUrl={logoUrl ?? null}
      fallback={<Store size={22} aria-hidden />}
      label="vendor logo"
      hasOwnLogo={!!logoUrl}
      editable={editable}
      upload={async (file) => {
        const { uploadUrl, s3Key } = await getVendorLogoUploadUrl(vendorId, file.name, file.type);
        await uploadFileToS3(uploadUrl, file);
        return setVendorLogo(vendorId, s3Key);
      }}
      clear={() => deleteVendorLogo(vendorId)}
      onChanged={() => queryClient.invalidateQueries({ queryKey: ['vendors'] })}
      onExpired={() => queryClient.invalidateQueries({ queryKey: ['vendors', vendorId] })}
      sizeClassName={sizeClassName}
      inputTestId="vendor-logo-file-input"
    />
  );
}
